import { identity, noop } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import './RadioButton.scss';
import FastEqualComponent from '../../FastEqualComponent/FastEqualComponent';
import { coalesce } from '../../../utils/utils';

require('animate.css/animate.min.css');

let defaultIdCounter = 0;

export class RadioButton extends FastEqualComponent {
  constructor(props) {
    super(props);
    this.defaultId = `radio-button-${++defaultIdCounter}`;
    this.state = {
      defaultValue: '',
      touched: false,
      value: '',
    };
    this.markTouched = this.markTouched.bind(this);
  }

  markTouched() {
    this.setState({ touched: true });
    return true;
  }

  render() {
    const {
      ariaLabel,
      category,
      checked,
      className = '',
      contextStyles,
      defaultValue,
      displayErrorMessage,
      error,
      disabled,
      onChange = noop,
      onClick = noop,
      id = this.defaultId,
      labelText,
      normalization = identity,
      required,
      value,
      accountNumber,
    } = this.props;

    const { touched } = this.state;

    return (
      <div className={`${className} radio-container`} disabled={disabled}>
        <input
          aria-label={coalesce(ariaLabel, labelText, value)}
          className={`custom-radio ${
            touched && error ? 'custom-radio-error' : ''
          } college-branded-radio-button`}
          checked={!!checked}
          disabled={disabled}
          defaultValue={defaultValue}
          id={id}
          name={category}
          onChange={() => this.markTouched() && onChange(normalization(value))}
          onClick={() => this.markTouched() && onClick(normalization(value))}
          required={required}
          style={contextStyles}
          type="radio"
          value={value}
          tabIndex="0"
          bigTest={'test'}
          data-testid={accountNumber}
        />
        <label htmlFor={`${id}`}>{labelText}</label>
        {displayErrorMessage && error && touched && (
          <div className="redio-button-errorMessage">{error}</div>
        )}
      </div>
    );
  }
}

RadioButton.propTypes = {
  id: PropTypes.string,
  labelText: PropTypes.node,
  name: PropTypes.string,
  required: PropTypes.bool,
};

RadioButton.defaultProps = {
  disabled: false,
  required: false,
};

export default RadioButton;
